require('./retailLoanImageGallery.scss');

//@vendor
const React = require('react');
const isEqual = require('lodash/lang/isEqual');
const PropTypes = require('prop-types');
const ReactImageZoom = require('react-image-zoom');
const classnames = require('classnames');

//component
const RetailLoanFullImageModal = require('../retailLoanFullImageModal/retailLoanFullImageModal');

//@constants
const {
    POSITION_RIGHT,
    MAIN_IMAGE_WIDTH,
    MAIN_IMAGE_SCALE,
    MAIN_IMAGE_SCALE_INFO,
    MAIN_IMAGE_RIGHT,
    MAIN_IMAGE_LEFT,
    MAIN_IMAGE_TOP,
    MAIN_IMAGE_MODAL_TOP,
    MAIN_IMAGE_MODAL_RIGHT
} = require('../../../../loansConstants/index').retailLoanGallery;
const headStyleClass = "retail-loan-image-gallery";
const placeHolder = require('../../../../assets/images/placeHolder.png');


class RetailLoanImageGallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            zoom: this.props.zoom,
            mainImageError: false,
        }
    }

    buildClassesOfImagesList(item) {
        const {
            galleryPosition,
            itemImageSeleted,
        } = this.props;

        const picturesSize = isEqual(galleryPosition, POSITION_RIGHT) ? '__picture-small' : '__picture-medium';

        const classNameImage = isEqual(itemImageSeleted.get('target_id'), item.get('target_id')) ?
            `${headStyleClass}${picturesSize} ${headStyleClass}${picturesSize}--selected` : `${headStyleClass}${picturesSize}`;

        const classNameContentImage = isEqual(galleryPosition, POSITION_RIGHT) ?
            `${headStyleClass}__container-picture-small` : `${headStyleClass}__container-picture-small col-md-4 col-lg-4`

        return { classNameImage, classNameContentImage };
    }

    onLoadErrorImage(e) {
        e.target.src = placeHolder;
        this.setState({
            zoom: false,
            mainImageError: true
        });
    }

    buildListOfImages(item, idx) {
        const { onHandleChangeSelectedImage } = this.props;
        const buildListOfImagesClasses = this.buildClassesOfImagesList(item);

        return (
            <div key={idx} className={buildListOfImagesClasses.classNameContentImage}
                onClick={() => onHandleChangeSelectedImage(item, idx)}>
                <img
                    className={buildListOfImagesClasses.classNameImage}
                    src={item.get('url')}
                    onError={(e) => this.onLoadErrorImage(e)}
                />
            </div>
        );
    }

    getZoomImage() {
        const {
            isModal,
            itemImageSeleted,
            mainImageWidth,
            zoomSide,
            galleryPosition
        } = this.props;

        const classNamePictureBigZoom = classnames(`${headStyleClass}__picture-big-zoom`, {
            'retail-loan-image-gallery__picture-big-zoom--modal': isModal
        });
        let offset = {};
        const isPositionRight = isEqual(galleryPosition, POSITION_RIGHT);

        switch (zoomSide) {
            case 'left':
                offset = {
                    vertical: MAIN_IMAGE_TOP,
                    horizontal: MAIN_IMAGE_LEFT
                };
                break;
            case 'modal':
                offset = {
                    vertical: MAIN_IMAGE_MODAL_TOP,
                    horizontal: MAIN_IMAGE_MODAL_RIGHT
                };
                break;
            default:
                offset = {
                    vertical: MAIN_IMAGE_TOP,
                    horizontal: MAIN_IMAGE_RIGHT
                };
                break;
        }

        const reactImageZoomProps = {
            scale: isPositionRight ? MAIN_IMAGE_SCALE : MAIN_IMAGE_SCALE_INFO,
            width: mainImageWidth || MAIN_IMAGE_WIDTH,
            img: itemImageSeleted.get('url'),
            offset,
            zoomStyle: 'background-color: white; border: 1px solid #CCC; z-index: 10'
        };

        return (
            <div className={classNamePictureBigZoom}>
                <ReactImageZoom {...reactImageZoomProps} />
            </div>
        );
    }

    buildMainImage() {
        const { itemImageSeleted } = this.props;
        const { zoom, mainImageError } = this.state;
        const mainClassName = classnames(`${headStyleClass}__picture-big`,
            {
                'retail-loan-image-gallery__picture-big--hide': zoom
            });

        const zoomImage = zoom && !mainImageError ? this.getZoomImage() : null;
        const mainImage = (
            <img className={mainClassName}
                title={itemImageSeleted.get('alt')}
                src={itemImageSeleted.get('url')}
                onError={(e) => this.onLoadErrorImage(e)}
            />
        );

        return (
            <React.Fragment>
                {mainImage}
                {zoomImage}
            </React.Fragment>
        );
    }

    buildGalleryClasses() {
        const {
            galleryPosition,
            isModal,
            modalMoreInformation
        } = this.props;
        const { zoom } = this.state;

        const classNamePicture = classnames(`${headStyleClass}__picture`, {
            'retail-loan-image-gallery__picture--modal': isModal
        });
        const classNameContentImage = isEqual(galleryPosition, POSITION_RIGHT) ?
            `${headStyleClass}__picture col-md-9 col-lg-9`
            : classNamePicture;

        let classMainImage = `${headStyleClass}__container-picture-big`;
        classMainImage += (zoom && modalMoreInformation) ? ` ${headStyleClass}__container-zoom` : '';
        classMainImage += !isEqual(galleryPosition, POSITION_RIGHT) ? ` ${headStyleClass}__container-zoom--center` : '';

        const mainImageContainer = this.buildMainImage();
        const classNameGalleryPicture = isEqual(galleryPosition, POSITION_RIGHT) ?
            `${headStyleClass}__pictures-array-right col-md-3 col-lg-3`
            : `${headStyleClass}__pictures-array`;

        return {
            classNameContentImage,
            classMainImage,
            mainImageContainer,
            classNameGalleryPicture
        };
    }

    buildGallery() {
        const {
            listImages,
            onHandleToggleModal
        } = this.props;
        const galleryClasses = this.buildGalleryClasses();

        return (
            <React.Fragment>
                <div className={galleryClasses.classNameContentImage}>
                    <div className={galleryClasses.classMainImage} onClick={onHandleToggleModal}>
                        {galleryClasses.mainImageContainer}
                    </div>
                </div>
                <div className={galleryClasses.classNameGalleryPicture}>
                    {listImages.map((item, index) => this.buildListOfImages(item, index))}
                </div>
            </React.Fragment>
        );
    }

    render() {
        const {
            isModal,
            itemImageSeleted,
            onHandleToggleModal,
            showModalFullImagen
        } = this.props;

        const gallery = this.buildGallery();
        const mainClassName = classnames(`col-md-12 ${headStyleClass}__pictures`, {
            'retail-loan-image-gallery__pictures--modal': isModal
        });

        return (
            <div className={mainClassName} >
                <RetailLoanFullImageModal
                    urlImage={itemImageSeleted.get('url')}
                    showModal={showModalFullImagen}
                    onHandleToggleModal={onHandleToggleModal}
                />
                {gallery}
            </div >
        );
    }

}

RetailLoanImageGallery.propTypes = {
    listImages: PropTypes.object.isRequired,
    galleryPosition: PropTypes.string,
    indexImageSeleted: PropTypes.number.isRequired,
    isModal: PropTypes.bool,
    itemImageSeleted: PropTypes.object.isRequired,
    mainImageWidth: PropTypes.number,
    modalMoreInformation: PropTypes.bool,
    onHandleChangeSelectedImage: PropTypes.func,
    onHandleToggleModal: PropTypes.func,
    showModalFullImagen: PropTypes.bool.isRequired,
    zoom: PropTypes.bool,
    zoomSide: PropTypes.string,
    fullImage: PropTypes.bool
};

export { RetailLoanImageGallery };
